// extracted by mini-css-extract-plugin
module.exports = {"shadow":"bulkActionButton_shadow__aeiAB"};